export default __webpack_public_path__ + "media/images/features/ja/megumino-2ac998a4ccf38f1d6294ec0936f41c62.jpg";